// Throttle
export function throttle(func, delay) {
    let timer = null
    return function () {
        const _this = this
        const args = []
        for (let _len = arguments.length, _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key]
        }
        if (timer === null) {
            timer = setTimeout(function () {
                func.apply(_this, args)
                timer = null
            }, delay)
        }
    }
}
